<p-confirmDialog
  #cd
  [closable]="false"
  [draggable]="false"
  styleClass="!w-[calc(100vw-2rem)] sm:!w-[32rem]"
>
  <ng-template #header>
    <span
      [id]="cd.ariaLabelledBy"
      class="block w-full text-center text-xl font-bold"
      [class.text-primary-700]="cd.getAcceptButtonProps().severity !== 'danger'"
      [class.text-red-700]="cd.getAcceptButtonProps().severity === 'danger'"
      >{{ cd.header }}</span
    >
  </ng-template>
  <ng-template #message let-confirmation>
    <span
      class="text-surface-500 block w-full text-center"
      [innerHTML]="confirmation?.message"
    ></span>
  </ng-template>
  <ng-template #footer>
    <div class="flex w-full justify-center gap-2">
      @if (cd.option('rejectVisible')) {
        <p-button
          [label]="cd.rejectButtonLabel"
          [styleClass]="cd.getButtonStyleClass('pcRejectButton', 'rejectButtonStyleClass')"
          [buttonProps]="cd.getRejectButtonProps()"
          (onClick)="cd.onReject()"
        />
      }
      @if (cd.option('acceptVisible')) {
        <p-button
          [label]="cd.acceptButtonLabel"
          [styleClass]="cd.getButtonStyleClass('pcAcceptButton', 'acceptButtonStyleClass')"
          [buttonProps]="cd.getAcceptButtonProps()"
          (onClick)="cd.onAccept()"
        />
      }
    </div>
  </ng-template>
</p-confirmDialog>
